import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { TweenMax } from 'gsap';
import { finalize, take } from 'rxjs/operators';
import { EventTypes } from '../../shared/EventTypes';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { LimiteGlobalService } from './limite-global.service';
import { LimiteGlobal } from './models/limite-global';

@Component({
	selector: 'app-limite-global',
	templateUrl: './limite-global.component.html',
	styleUrls: ['./limite-global.component.styl'],
	encapsulation: ViewEncapsulation.None,
})
export class LimiteGlobalComponent implements OnInit, OnDestroy {
	time: number;
	timeLoaderStatus: any;

	limiteGlobal: LimiteGlobal;

	constructor(private limiteGlobalService: LimiteGlobalService) {}

	ngOnInit(): void {
		this.limiteGlobalService.refreshLG.asObservable().subscribe((refresh) => {
			if (refresh) {
				this.getStatus();
			}
		});
	}

	ngOnDestroy(): void {
		this.clearIntervalStatus();
	}

	private clearIntervalStatus(): void {
		if (this.timeLoaderStatus) {
			clearInterval(this.timeLoaderStatus);
		}
		this.time = 1;
	}

	private getStatus(): void {
		this.preload(true);

		this.time = 1;
		this.timeLoaderStatus = setInterval(() => {
			this.time++;
		}, 1000);

		this.limiteGlobalService
			.getGlobalLimitConsulta()
			.pipe(
				finalize(() => {
					this.preload(false);
					this.clearIntervalStatus();
				}),
				take(1)
			)
			.subscribe(
				(res) => {
					if (res && res.Retorno) {
						this.limiteGlobal = res.Retorno.Contrato;
					}
				},
				(error) => {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {
						msg: error.error.Mensagem,
					});
				}
			);
	}

	private async preload(active: boolean): Promise<void> {
		let delay = 0;
		if (!active && this.time <= 3) {
			delay = 3 - this.time;
			await new Promise<void>((resolve) =>
				TweenMax.delayedCall(delay, resolve)
			);
		}
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {
			element: '[data-component="limite-global"] .content',
			show: active,
			delay: delay,
		});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/limite-global/limite-global.component.ts